import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
  NgModule,
  isDevMode,
} from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandleService } from './shared/services/error-handle/error-handle.service';
import { SessionStorageService } from './shared/services/storage/sessionstorage/sessionstorage.service';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { StringRedux } from './shared/pipes/string-redux/string-redux.pipe';
import { RequestService } from './shared/services/request/request.service';

import { DashboardComponent } from './dashboard/dashboard.component';
import { NgxMaskModule, NgxMaskService } from 'ngx-mask';

import { QuillModule } from 'ngx-quill';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';

defineLocale('pt-br', ptBrLocale);
import { ModalAvaliacaoComponent } from './shared/components/modais/modal-avaliacao/modal-avaliacao.component';
import { ModalAtualizacaoCadastroComponent } from './shared/components/modal-atualizacao-cadastro/modal-atualizacao-cadastro.component';
import { ModalNotificacaoPermissaoComponent } from './shared/components/modais/modal-notificacao-permissao/modal-notificacao-permissao.component';
import { TarefasComponent } from './tarefas/tarefas.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { RedefinirSenhaComponent } from './login/redefinir-senha/redefinir-senha.component';

@NgModule({
  declarations: [AppComponent, StringRedux, ModalNotificacaoPermissaoComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ModalModule.forRoot(),
    FontAwesomeModule,
    HeaderComponent,
    DashboardComponent,
    HomeComponent,
    ModalAvaliacaoComponent,
    ModalAtualizacaoCadastroComponent,
    RedefinirSenhaComponent,
    TarefasComponent,
    NgxMaskModule.forRoot(),
    QuillModule.forRoot(),
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    NgApexchartsModule,
    [],
  ],

  providers: [
    RequestService,
    ErrorHandleService,
    SessionStorageService,
    NgxMaskService,
    BsLocaleService,
  ],

  exports: [StringRedux],
  bootstrap: [AppComponent]

})
export class AppModule {

}
